import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  caption: string;
  'data-cy'?: string;
}

/**
 * Wraps policy tables with consistent styling and an accessible caption.
 */
export function PolicyTableWrapper({
  children,
  caption,
  'data-cy': dataCy,
}: Props) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-5 th-highcontrast:border-gray-7 th-dark:border-gray-7">
      <table className="w-full" data-cy={dataCy}>
        <caption className="sr-only">{caption}</caption>
        {children}
      </table>
    </div>
  );
}
